import * as yup from 'yup';

export interface OtpCodeModel {
  mobileNo: number;
}

export interface ValidateOtpCodeModel {
  mobileNo: string;
  code: number;
  otpAttemptCount: number;
}

export const OtpInputSchema = yup.object().shape({
  code: yup.string().when('$isNew', {
    is: true,
    then: fs => fs.required('OTP Code is required.').min(6, 'OTP Code must be 6 digits.'),
  }),
});
